import { hasLocalStorageSupportShim } from '../../../../widget/app/modules/utils/legacyUtils';
import { Logger } from '../../utils';
import { sanitizeString } from '../../utils/sanitizeString';
import { setSearchParams } from '../../utils/searchParamUtils';

const CACHE_KEY = 'selectedLocationCode';
const DEFAULT_LOCATION_SLUG = 'new-york-ny';

// Accounts for ResyLocations.setInitialLocation() non-Redux side-effects,
// that was called once from obsolete ResyLocations.load().
// Returns defaultLocation which is handled in initResyLocationsThunk(),
// and this value is then dispatched to setSelected().

// For this function, persist Angular props as Consumer Web will need to relocate
// initResyLocationsConfigThunk() to a React Router context.
function setInitialLocationAngularSideEffects(resyLocations, $rootScope, $route, $routeParams) {
  let urlSlug = resyLocations.nearest || DEFAULT_LOCATION_SLUG;
  let isStoredLocation = false;
  const hasLocalStorageSupport = hasLocalStorageSupportShim(window);

  if ('location' in $routeParams) {
    // word slug, e.g. 'new-york-ny'
    if (Number.isNaN(+$routeParams.location)) {
      urlSlug = $routeParams.location;

      // numeric code
    } else {
      const urlLocation = resyLocations.all.find((location) => location.id === +$routeParams.location);

      if (urlLocation) {
        ({ url_slug: urlSlug } = urlLocation);
        $route.updateParams({ location: urlSlug });
      }
    }
  } else if (hasLocalStorageSupport) {
    const storedLocation = window.localStorage.getItem(CACHE_KEY);
    let selectedLocationSlug;
    try {
      selectedLocationSlug = JSON.parse(storedLocation);
    } catch (e) {
      Logger.error('[ERROR] parsing selected location from localStorage', e);
      selectedLocationSlug = null;
    }

    if (selectedLocationSlug) {
      urlSlug = selectedLocationSlug;
      isStoredLocation = true;
    }
  }

  let defaultLocation = (!isStoredLocation)
    ? resyLocations.web.find((location) => location.url_slug === urlSlug)
    : resyLocations.all.find((location) => location.url_slug === urlSlug);

  if (!defaultLocation) {
    const bestLocationSlug = resyLocations.nearest || DEFAULT_LOCATION_SLUG;

    // If we're on the home or search page and were given a city that we don't have, default to location.nearest or 'new-york-ny'
    if (!('location' in $routeParams) || ('location' in $routeParams && !('venueSlug' in $routeParams))) {
      $route.updateParams({ location: bestLocationSlug });
      defaultLocation = resyLocations.web.find((location) => location.url_slug === bestLocationSlug);
    } else {
      defaultLocation = {
        urlSlug,
        name: null,
        hideMenu: true,
      };
    }
  }

  setSearchParams('location', null);
  return defaultLocation;
}

// Accounts for obsolete ResyLocations.setSelected() non-Redux side-effects
// Actual Redux action is dispatched in setSelectedLocationThunk()
function setSelectedLocationAngularSideEffects(location) {
  const hasLocalStorageSupport = hasLocalStorageSupportShim(window);
  if (hasLocalStorageSupport && location?.url_slug) {
    window.localStorage.setItem(CACHE_KEY, sanitizeString(JSON.stringify(location.url_slug)));
  }
  window.resyLocation = location?.url_slug; // eslint-disable-line
}

export {
  DEFAULT_LOCATION_SLUG,
  setInitialLocationAngularSideEffects,
  setSelectedLocationAngularSideEffects,
};
